/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from 'react'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import {useMutation} from 'react-query'
import {AxiosError} from 'axios'
import {toast} from 'react-toastify'

import {login} from '../core/_requests'
import {useAuth} from '../core/Auth'
import {loginModel} from '../form/models'
import {LoginModel} from '../core/_models'

const inputStyle: React.CSSProperties = {
  background: '#0d1117',
  border: '1px solid #1e2a3d',
  borderRadius: '10px',
  color: '#e2e8f0',
  padding: '12px 16px',
  width: '100%',
  fontSize: '16px',
  outline: 'none',
}

export function LoginForm() {
  const {saveAuth, setCurrentUser} = useAuth()
  const [loading, setLoading] = useState(false)

  const {mutate} = useMutation('login', async (values: LoginModel) => {
    const res = await login(values.email, values.password)
    return res
  })

  const formik = useFormik({
    initialValues: loginModel.initials,
    validationSchema: loginModel.schema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      mutate(values, {
        onSuccess: ({auth, user}) => {
          saveAuth(auth)
          setCurrentUser(user)
          toast(`Welcome ${user.name || 'User'}!`)
        },
        onError: (error) => {
          const errMsg =
            ((error as AxiosError).response?.data as any)?.message ||
            'The login detail is incorrect'
          toast(errMsg, {type: 'error'})
          saveAuth(undefined)
          setStatus(errMsg)
        },
        onSettled: () => {
          setSubmitting(false)
          setLoading(false)
        },
      })
    },
  })

  return (
    <form onSubmit={formik.handleSubmit} noValidate id='kt_login_signin_form'>
      {/* Heading */}
      <div className='text-center mb-8'>
        <h2 className='fw-bold mb-2' style={{color: '#f1f5f9', fontSize: '22px'}}>
          Welcome back
        </h2>
        <p style={{color: '#64748b', fontSize: '13px', margin: 0}}>
          Sign in to continue with your trader account.
        </p>
      </div>

      {formik.status && (
        <div
          className='mb-6 p-3 rounded'
          style={{
            background: '#2a1010',
            border: '1px solid #E84040',
            color: '#f87171',
            fontSize: '13px',
          }}
        >
          {formik.status}
        </div>
      )}

      {/* Email */}
      <div className='mb-5'>
        <label style={{color: '#94a3b8', fontSize: '13px', marginBottom: '6px', display: 'block'}}>
          Email
        </label>
        <input
          type='email'
          placeholder='Type your email'
          style={inputStyle}
          {...formik.getFieldProps('email')}
        />
        {formik.touched.email && formik.errors.email && (
          <p style={{color: '#f87171', fontSize: '12px', marginTop: '4px'}}>
            {formik.errors.email}
          </p>
        )}
      </div>

      {/* Password */}
      <div className='mb-3'>
        <div className='d-flex justify-content-between align-items-center mb-1'>
          <label style={{color: '#94a3b8', fontSize: '13px', margin: 0}}>Password</label>
          <Link
            to='/auth/forgot-password'
            style={{color: '#6366f1', fontSize: '12px', textDecoration: 'none'}}
          >
            Forgot password?
          </Link>
        </div>
        <input
          type='password'
          placeholder='Type your password'
          style={inputStyle}
          {...formik.getFieldProps('password')}
        />
        {formik.touched.password && formik.errors.password && (
          <p style={{color: '#f87171', fontSize: '12px', marginTop: '4px'}}>
            {formik.errors.password}
          </p>
        )}
      </div>

      {/* Continue button */}
      <button
        type='submit'
        className='w-100 mt-6 mb-4 fw-bold'
        disabled={formik.isSubmitting || loading}
        style={{
          background: 'linear-gradient(135deg, #4f6ef7 0%, #6366f1 100%)',
          border: 'none',
          borderRadius: '10px',
          color: '#fff',
          padding: '13px',
          fontSize: '14px',
          cursor: 'pointer',
          opacity: formik.isSubmitting || loading ? 0.6 : 1,
        }}
      >
        {loading ? (
          <span>
            Please wait...
            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
          </span>
        ) : (
          'Continue'
        )}
      </button>
    </form>
  )
}
